export const mapLotToHedgeRedirect = data => ({
  name: data.grgLotNumber,
  id: data.id,
  receivedAt: data.receivedAt,
  statusForGlobal: data.statusForGlobal,
  statusForCustomer: data.statusForCustomer,
  hedge: data.hedge,
});
